export default __webpack_public_path__ + "static/island-life-mobile-3864dd0d3861dcc27d20de7b814dae81.webp";